// @flow
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import path from 'ramda/es/path';
import pick from 'ramda/es/pick';
import values from 'ramda/es/values';
import includes from 'ramda/es/includes';

import * as statuses from 'app/common/constants/students/statuses';
import api from 'app/actions/api';
import action from 'app/common/lib/action';
import { toCamelCase } from 'app/common/lib/object';


export const STUDENTS_REQUEST = 'users/STUDENTS_REQUEST';
export const STUDENTS_SUCCESS = 'users/STUDENTS_SUCCESS';
export const STUDENTS_FAILURE = 'users/STUDENTS_FAILURE';
export const STUDENTS_CANCEL = 'users/STUDENTS_CANCEL';
export const STUDENTS_CLEAR = 'users/STUDENTS_CLEAR';

const isStatusAvailable = status => includes(status, values(statuses));
export const dateFormat = 'YYYY-MM-DD';


// * ВОЗМОЖНО ТАКОГО ЗАПРОСА НЕТ

type Params = {
  status?: number,
  limit?: number,
  offset?: number,
  student_id?: number,
  search?: string,
  year_id?: Array<number>,
  class_id?: Array<number>,
  has_identifier?: boolean,
  has_curator?: boolean,
  has_active_subsidy_order?: boolean,
}
// Запрос списка учеников по параметрам
export const studentsFetch = (params: Params) => async (dispatch: Function) => {
  dispatch(action(STUDENTS_REQUEST, params));

  if (!isStatusAvailable(params.status)) {
    dispatch(action(STUDENTS_FAILURE, { err: 'Неверный статус запрашиваемых учеников' }));
    return null;
  }
  try {
    const res = await api.request('journal/students2', 'get', { params });
    const students = pipe(
      prop('data'),
      pick(['students', 'students_count', 'pending_count']),
      toCamelCase
    )(res);
    dispatch(action(STUDENTS_SUCCESS, students));
    return students;
  } catch (error) {
    if (error instanceof Error) {
      dispatch(action(STUDENTS_FAILURE, { err: 'Не удалось получить данные учеников', error, params }));
    } else {
      dispatch(action(STUDENTS_CANCEL));
    }
    return null;
  }
};


export const STUDENT_REQUEST = 'users/STUDENT_REQUEST';
export const STUDENT_SUCCESS = 'users/STUDENT_SUCCESS';
export const STUDENT_FAILURE = 'users/STUDENT_FAILURE';

// Запрос одного ученика
export const studentFetch = (id: number) => async (dispatch: Function) => {
  const params = { student_id: id };
  dispatch(action(STUDENT_REQUEST, id));

  try {
    const res = await api('journal/students2', 'get', { params });
    const student = pipe(
      path(['data', 'students']),
      toCamelCase
    )(res);
    dispatch(action(STUDENT_SUCCESS, student));
    return student;
  } catch (error) {
    dispatch(action(STUDENT_FAILURE, { err: 'Не удалось получить данные ученика', error, params }));
    return null;
  }
};
